import { createContext, useContext } from 'react';
import { ReportFoldersFilters } from '@views/pages/Reporting/ReportFolders/types.ts';

type ReportFoldersContextType = {
  filters: ReportFoldersFilters;
  handleFilterChange: (filters: Partial<ReportFoldersFilters>) => void;
  isInitialFilters: boolean;
};

export const ReportFoldersContext =
  createContext<ReportFoldersContextType | null>(null);

export const useReportFoldersContext = () => {
  const context = useContext(ReportFoldersContext);
  if (!context) {
    throw new Error(
      'The useReportFoldersContext hook must be used within a ReportFoldersContext.',
    );
  }
  return context;
};
